import { client } from '../utils/fetch';

const API_ENDPOINT = 'scenarios/manage';
const GET_SCENARIOS_ENDPOINT = 'scenarios';

export interface ScenarioCondition {
  id: string;
  type: string;
  name: string;
  value: string;
  mac: string;
}

export interface ScenarioAction {
  id: string;
  target_type: string;
  target: string[];
  type: string;
  value: (string | number)[];
}

export interface ScenarioItem {
  id?: number; // Optional - exists for scenarios from database, undefined for new scenarios
  store_id?: string; // From database response
  conditions: ScenarioCondition[];
  actions: ScenarioAction[];
  ai_tags: (string | number)[];
}

export interface ScenarioManageRequest {
  store_id: string;
  items: ScenarioItem[];
  delete_missing: boolean;
}

export interface ScenarioManageResponse {
  message: string;
}

// Response structure from GET /scenarios endpoint
export interface GetScenariosResponse {
  [key: string]: ScenarioItem[];
}

export const postScenarios = async (
  storeId: string,
  scenarios: ScenarioItem[],
  deleteMissing: boolean = false
): Promise<ScenarioManageResponse> => {
  try {
    const requestBody: ScenarioManageRequest = {
      store_id: storeId,
      items: scenarios,
      delete_missing: deleteMissing,
    };

    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    const response = await client.post<ScenarioManageResponse>(
      API_ENDPOINT,
      requestBody,
      headers
    );

    return response;
  } catch (error) {
    console.error("Error posting scenarios:", error);
    throw error;
  }
};

export const getScenarios = async (storeId: string): Promise<ScenarioItem[]> => {
  try {
    const response = await client.get<GetScenariosResponse>(
      `${GET_SCENARIOS_ENDPOINT}?store_id=${storeId}`
    );

    // The response is an array of scenario items
    // Based on the screenshot, it looks like the response is directly an array
    if (Array.isArray(response)) {
      return response;
    } else {
      // If it's an object with store_id as key, extract the array
      const storeScenarios = Object.values(response)[0];
      return Array.isArray(storeScenarios) ? storeScenarios : [];
    }
  } catch (error) {
    console.error("Error fetching scenarios:", error);
    throw error;
  }
}; 